/* eslint-disable @typescript-eslint/no-base-to-string */
import {ottopilotDialPhoneNumber} from "~/components/ottopilotDataViewer/listCardPresentation";
import type {KanbanCardPhoneDial} from "~/components/ottopilotDataViewer/rowEngagement/KanbanCardRowActions";

/** Builds kanban upfront call button state from a contact column value. */
export function resolveKanbanPhoneDial(contactRaw: unknown, displayFallback?: string): KanbanCardPhoneDial {
    if (contactRaw === null || contactRaw === undefined) {
        return {telHref: "tel:", isDisabled: true};
    }

    const display = displayFallback ?? String(contactRaw).trim();
    const tel = String(contactRaw).replace(/\s+/g, "").trim();
    if (tel === "") {
        return {telHref: "tel:", isDisabled: true};
    }

    return {
        telHref: `tel:${tel}`,
        tooltip: display !== "" && display !== "-" ? `Contact Number: ${display}` : undefined,
        onDial: () => {
            ottopilotDialPhoneNumber(tel);
        },
    };
}
